<template>
  <span class="badge border border-primary text-primary" v-if="filter.includes(consumo)" style="font-size: 12px">
    <i class="fa fa-shopping-basket mr-1"></i> {{ consumo | tipo_consumo }}
  </span>
</template>

<script>
export default {
  name: "ProdutoConsumo",
  props: ['consumo', 'tipo_pedido'],
  data() {
    return {
      filter: this.tipo_pedido === '3' ? ['2','3','5'] : ['2','3','4','6']
    }
  },

  filters: {
    tipo_consumo(tipo) {
      switch (tipo) {
        case '2':
          return 'Retirar no local';
        case '3':
          return 'Apenas entregas';
        case '4':
          return 'Consumir no local';
        case '5':
          return 'Para retirar e entregar';
        case '6':
          return 'Retirar e consumir no local';
      }
    }
  }
}
</script>

<style scoped>
</style>